import $ from 'jquery';
window.$ = $;

import './typesense_search';
import './bootstrap_validation';
import './copy_template';
import './date_time_picker';
import './form_search_field';
import './modal_buttons';
import './prompt_button';
import './sidebar';
import './uppy_plugin';
import './pdf_viewer';
import './tippy';
import 'bootstrap-table/dist/bootstrap-table.min.js';

import '../scss/main.scss';
import 'flatpickr/dist/themes/material_blue.css'
import '@algolia/autocomplete-theme-classic';
import 'bootstrap-table/dist/bootstrap-table.min.css';
